export interface SupplierPrice {
  id: number;
  supplierId: number;
  ancho: number;
  largo: number;
  color: string;
  microns: number;
  unitPrice: number;
  note: string;
  updatedAt: string;
}

export interface SupplierLastPaid {
  ancho: number;
  largo: number;
  color: string;
  microns: number;
  unitPrice: number;
  receiptDate: string;
}

export interface SupplierPriceData {
  prices: SupplierPrice[];
  lastPaid: SupplierLastPaid[];
}

export interface SuggestedPrice {
  unitPrice: number;
  source: 'lista' | 'ultimo';
  receiptDate?: string;
}

interface Article { ancho: number; largo: number; color: string; microns: number; }

// Same measure and color; exact microns first, then an entry without microns (valid for any),
// then, for a line without microns, the only entry of that measure and color.
const findArticle = <T extends Article>(entries: T[], line: Article): T | undefined => {
  const candidates = entries.filter((entry) => Number(entry.ancho) === Number(line.ancho) && Number(entry.largo) === Number(line.largo) && entry.color === line.color);
  return candidates.find((entry) => Number(entry.microns || 0) === Number(line.microns || 0))
    || candidates.find((entry) => !Number(entry.microns || 0))
    || (!Number(line.microns || 0) && candidates.length === 1 ? candidates[0] : undefined);
};

export const suggestSupplierPrice = (data: SupplierPriceData | null, line: Article): SuggestedPrice | null => {
  if (!data) return null;
  const listed = findArticle(data.prices, line);
  if (listed) return { unitPrice: listed.unitPrice, source: 'lista' };
  const last = findArticle(data.lastPaid, line);
  return last ? { unitPrice: last.unitPrice, source: 'ultimo', receiptDate: last.receiptDate } : null;
};
